// Mock data for Xxpand CRM landing page

export const NAV_LINKS = [
  {
    label: 'Features',
    columns: [
      {
        heading: 'Marketing & Sales',
        items: ['Website Builder', 'All In One Social Media Management', 'Unified Communication Hub', 'Search Engine Optimization', 'WhatsApp Marketing', 'Reputation Management', 'Email Marketing'],
      },
      {
        heading: 'CRM & Employees Management',
        items: ['Pipeline Management', 'Lead Management', 'Appointment Scheduling', 'Contact Management', 'Chat Widget', 'Membership Management', 'Retargeting Automations', 'Team Task Management'],
      },
      {
        heading: 'Sales & Revenue Optimization',
        items: ['Quoting & Invoicing', 'Payment integration', 'Course Sales', 'Affiliate Management', 'Sales Funnels'],
      },
      {
        heading: 'Business Automation & Insights',
        items: ['Workflow Automations', 'Dashboards & Analytics', 'Funnel & Website Analytics', 'Call Tracking & Recording'],
      },
    ],
  },
  {
    label: 'CRM For',
    items: ['Hotels & Resorts', 'Real Estate', 'Travel Agency', 'Cleaning Business', 'Small & Medium Enterprise', 'Salon and Spa', 'Handyman Services', 'Healthcare', 'Coaching & Institutes', 'HoReCa'],
  },
  {
    label: 'Ecosystem',
    items: ['Licensee Program', 'Xxpand Academy', 'Hire CRM VA', 'CRM Custom Builds'],
  },
  { label: 'Pricing' },
  {
    label: 'Resources',
    items: ['Blogs', 'Case Studies', 'Automations', 'FAQs'],
  },
];

export const CLIENT_LOGOS = [
  'HOC Materials', 'Cosmo Pharma', 'Unico', 'Structofit', 'Eco Services', 'Hair Museum',
  'Xxpand Marketing', 'Bilal Traders', 'Sadiqeen Group', 'IT Air Travels', 'Luna Corp', 'Safar Mubarak', 'Bano Qabil',
];

export const PILLARS = [
  {
    number: '01',
    title: 'Marketing & Lead Generation',
    desc: 'Strategize a comprehensive marketing strategy using Xxpand tools, streamline your sales process, and drive business growth.',
    icon: 'Megaphone',
  },
  {
    number: '02',
    title: 'CRM & Customer Management',
    desc: 'Build meaningful relationships, manage leads, and keep your customers coming back with ease.',
    icon: 'Users',
  },
  {
    number: '03',
    title: 'Sales & Revenue Growth',
    desc: 'Streamline your sales processes, boost revenue, and create scalable growth opportunities.',
    icon: 'TrendingUp',
  },
  {
    number: '04',
    title: 'Automation & Business Intelligence',
    desc: 'Work smarter, not harder. Save time, reduce manual tasks, and make data-driven decisions with powerful automation.',
    icon: 'BrainCircuit',
  },
];

export const MARKETING_TOOLS = [
  { title: 'No Code Website Builder', desc: 'Drag and drop website builder with 1000+ ready-to-use themes.', icon: 'LayoutTemplate', highlight: true },
  { title: 'All In 1 Social Media Management', desc: 'Manage all social channels from 1 dashboard.', icon: 'Share2', highlight: true },
  { title: 'All-in-One Communication Hub', desc: 'Centralize your messages for smooth communication.', icon: 'MessagesSquare', highlight: true },
  { title: 'Email Marketing & Automations', desc: 'Create campaigns that connect, retarget and grow your revenue.', icon: 'Mail' },
  { title: 'WhatsApp Marketing & Automations', desc: 'Create WhatsApp automations, send unlimited messages.', icon: 'MessageCircle', highlight: true },
  { title: 'Invoicing & Payment Tools', desc: 'Share invoices directly! Get paid on single click.', icon: 'Receipt', highlight: true },
  { title: 'Sale Funnels', desc: 'Bring all messaging into one platform SMS, email, and social.', icon: 'Filter' },
  { title: 'Search Engine Optimization', desc: 'Manage website SEO, Schemas, and content from your own CRM.', icon: 'Search' },
  { title: 'Reputation Management', desc: 'Engage and grow your loyal audience.', icon: 'Star', highlight: true },
];

export const CRM_TOOLS = [
  { title: 'CRM & Leads Management', desc: 'Stay on top of your prospects with ease.', icon: 'UserPlus', highlight: true },
  { title: 'Pipelines Management', desc: 'Track every stage of your customer journey.', icon: 'GitBranch', highlight: true },
  { title: 'Teams Task Management', desc: 'Assign and track tasks effortlessly.', icon: 'ClipboardList', highlight: true },
  { title: 'Appointment Scheduling', desc: "Don't worry about calendly anymore, use our native calendars.", icon: 'CalendarDays' },
  { title: 'Contact Management', desc: 'Stay on top of your prospects with ease.', icon: 'Contact' },
  { title: 'Retargeting Automations', desc: 'Retarget your past and existing customers with smart automations.', icon: 'Target' },
  { title: 'Membership Management', desc: 'Manage your customer memberships seamlessly.', icon: 'BadgeCheck' },
];

export const SALES_TOOLS = [
  { title: 'Sales Funnel', desc: 'Convert leads effortlessly with optimized funnels.', icon: 'Filter', highlight: true },
  { title: 'Quoting & Invoicing', desc: 'Simplify billing and close deals faster.', icon: 'FileText', highlight: true },
  { title: 'Payment Gateway Integration', desc: 'Make transactions easy for you and your clients.', icon: 'CreditCard', highlight: true },
  { title: 'Course Sales', desc: 'Create and sell courses directly from your platform.', icon: 'GraduationCap' },
];

export const AUTOMATION_TOOLS = [
  { title: 'Workflow Automations', desc: 'Automate repetitive tasks and save time.', icon: 'Workflow', highlight: true },
  { title: 'AI Employee', desc: 'Optimize client interactions with Conversation AI, Voice AI, Content writer AI and Review AI.', icon: 'Bot', highlight: true },
  { title: 'Call Tracking & Recording', desc: 'Track and record every call, Let AI analyse sales performance and train them.', icon: 'PhoneCall', highlight: true },
  { title: 'Dashboards & Analytics', desc: 'Gain insights and track progress effortlessly.', icon: 'BarChart3' },
  { title: 'Funnel & Website Analytics', desc: 'Understand your performance in real time.', icon: 'LineChart' },
];

export const INDUSTRIES = [
  'Hotels & Resorts', 'Real Estate', 'Travel Agency', 'Cleaning Business',
  'Small & Medium Enterprise', 'Salon and Spa', 'Handyman Services', 'Healthcare',
  'Coaching & Institutes', 'HoReCa', 'Restaurants', 'E-commerce',
];

export const INTEGRATION_LOGOS = [
  'Stripe', 'PayPal', 'Zapier', 'Slack', 'Google', 'Facebook', 'Instagram', 'WhatsApp',
  'Zoom', 'Twilio', 'Mailgun', 'Shopify', 'QuickBooks', 'Calendly',
];

export const FAQS = [
  {
    q: 'How does Xxpand simplify business automation?',
    a: 'Xxpand simplifies your operations with its four powerful pillars: Marketing & Promotion (email, social media, websites, reputation), CRM & Customer Management (leads, appointments, client interactions), Sales & Revenue Optimization (funnels, invoicing, payments), and Automation & Insights (workflow automation, AI assistance, analytics).',
  },
  {
    q: 'Can Xxpand help with marketing automation for small businesses?',
    a: 'Absolutely! Xxpand offers digital marketing automation software that includes email campaigns, social media management, and reputation monitoring, perfect for small businesses looking to grow without extra effort.',
  },
  {
    q: "How does Xxpand's CRM system help manage customers?",
    a: "Xxpand's CRM provides tools for lead management, contact organization, and pipeline tracking. It keeps all customer interactions in one place, making it easy to stay organized and deliver exceptional service.",
  },
  {
    q: "What's included in Xxpand's automation features?",
    a: "Xxpand's business process automation tools include workflow automation, AI-powered insights, retargeting campaigns, and even task automation for your team. These features save time and boost productivity.",
  },
  {
    q: 'Can Xxpand integrate with other apps?',
    a: 'Yes, Xxpand integrates with leading tools and platforms. Whether it\u2019s payment gateways, social media apps, or analytics tools, Xxpand connects them all seamlessly.',
  },
];

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1697806959316-4864f26a09cf?w=900&auto=format&fit=crop';
